import React from "react";

const ServiceHeader = ({ title, heading, text }) => {
    return (
        <div className="third-design-home-about-left-div third-design-service-header">
            <h2 data-aos="fade-right"
                data-aos-easing="ease-out-cubic"
                data-aos-delay="100"
                data-aos-offset="0"
                data-aos-duration="1500">{title}</h2>
            <h1>{heading}</h1>
            <p>{text}</p>
        </div>
    )
}

export default ServiceHeader